// extracted by mini-css-extract-plugin
export default {"languageSelector":"Language_languageSelector__hZFlk","divider":"Language_divider__BeSq-","activeLang":"Language_activeLang__J2vZX"};